// Компонент флаера

import {
  Box,
  Button,
  CardMedia,
  Typography,
  useMediaQuery,
} from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";

export const FlyerCard = ({ translations }) => {
  const isMobile = useMediaQuery("(max-width: 900px)");
  return (
    <Box
      sx={{
        width: "100%",
        height: "600px", // Fixed height for impact
        position: "relative",
        marginBottom: "50px",
        marginTop: "100px",
        overflow: "hidden",
        borderRadius: "8px",
        backgroundImage: 'url("/XXL_height.webp")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
      {/* Dark Overlay for readability */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent black overlay
          zIndex: 1,
        }}
      />

      {/* Content */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          textAlign: "center",
          color: "#fff",
          maxWidth: "800px",
          padding: "20px",
        }}>
        <Typography
          variant={isMobile ? "h4" : "h2"}
          component="h1"
          fontWeight="bold"
          gutterBottom
          sx={{
            textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
          }}>
          {translations["flyer_card_1"]}
        </Typography>
        <Typography
          variant={isMobile ? "body1" : "h5"}
          component="p"
          sx={{
            marginBottom: "30px",
            textShadow: "1px 1px 2px rgba(0,0,0,0.7)",
            opacity: 0.9,
          }}>
          {translations["flyer_card_2"]}
        </Typography>
        <Button
          variant="contained"
          size="large"
          sx={{
            backgroundColor: "#1976d2",
            color: "#fff",
            padding: "10px 30px",
            fontSize: "1.1rem",
            "&:hover": { backgroundColor: "#1565c0" },
          }}>
          {translations["flyer_card_btn"]}
        </Button>
      </Box>
    </Box>
  );
};
